import ErrorInfo from '@/components/error/ErrorInfo';
import Layout from '@/components/Layout';

const ErrorFallback = () => (
  <Layout>
    <ErrorInfo browserNavigationEnabled />
  </Layout>
);

export default ErrorFallback;
